import { ConfirmCancelModalState } from './ConfirmCancelModal.types';

type ConfirmCancelModalText = Record<
    ConfirmCancelModalState['action'],
    {
        title: string;
        description: string;
        submitLabel: string;
    }
>;

export const CONFIRM_CANCEL_MODAL_TEXT: ConfirmCancelModalText = {
    cancel: {
        title: 'Скасувати замовлення',
        description: 'Виберіть причину. Замовлення буде скасовано.',
        submitLabel: 'Скасувати замовлення',
    },
    reject: {
        title: 'Скасувати замовлення',
        description:
            'Виберіть причину скасування. Товари будуть повернуті в наявність.',
        submitLabel: 'Скасувати замовлення',
    },
};
